import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as api from './apis/mfa';
import { setTokens } from './setTokens';
import { emit, triggerError } from '../utils/eventManager';
import { sendNewRelicEvent } from '../utils/newRelicEvents';
export { sendEmail, doMfa, getMfaToken, isUserMfa };
function sendEmail(_x) {
  return _sendEmail.apply(this, arguments);
}
function _sendEmail() {
  _sendEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api.sendEmail(token);
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendEmail.apply(this, arguments);
}
function doMfa(_x2, _x3, _x4, _x5) {
  return _doMfa.apply(this, arguments);
}
function _doMfa() {
  _doMfa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mfaToken, oobCode, mfaCode, deviceId) {
    var tokens, idToken, accessToken;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          sendNewRelicEvent({
            EventName: 'mfa_start'
          });
          _context2.next = 4;
          return api.doMfa(mfaToken, oobCode, mfaCode, deviceId);
        case 4:
          tokens = _context2.sent;
          idToken = tokens.idToken, accessToken = tokens.accessToken;
          emit('login.success', tokens);
          sendNewRelicEvent({
            EventName: 'mfa_success'
          });
          _context2.next = 10;
          return setTokens({
            idToken: idToken,
            accessToken: accessToken,
            callInitSession: true
          });
        case 10:
          return _context2.abrupt("return", tokens);
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          sendNewRelicEvent({
            EventName: 'mfa_failed',
            error: _context2.t0
          });
          triggerError('mfa', _context2.t0);
          throw _context2.t0;
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  }));
  return _doMfa.apply(this, arguments);
}
function getMfaToken(_x6) {
  return _getMfaToken.apply(this, arguments);
}
function _getMfaToken() {
  _getMfaToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(clientId) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return api.getMfaToken(clientId);
        case 2:
          return _context3.abrupt("return", _context3.sent);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getMfaToken.apply(this, arguments);
}
function isUserMfa() {
  try {
    var accessToken = document.cookie.split('; ').find(function (c) {
      return c.includes('access_token=');
    });
    if (!accessToken) {
      return false;
    }
    var _accessToken$slice$sp = accessToken.slice(accessToken.indexOf('=') + 1).split('.'),
      _accessToken$slice$sp2 = _slicedToArray(_accessToken$slice$sp, 2),
      _ = _accessToken$slice$sp2[0],
      token = _accessToken$slice$sp2[1];
    var decodedToken = JSON.parse(atob(token));
    return !!decodedToken.chgmfa;
  } catch (e) {
    return false;
  }
}